import React from 'react';

import { ToolbarList, ToolbarListType } from '../../../workspace/toolbar/toolbarTypes';
import { ToolbarItemsListRequiredProps } from '../../../workspace/toolbar/components/ToolbarItemsList';

import MobileTabsToolList from './tabsToolList/MobileTabsToolList';
import MobileUtilsToolList from './utilsToolList/MobileUtilsToolList';
import MobileToolbarItemsList from './toolbarItemsList/MobileToolbarItemsList';
import MobileToolbarDoneButton from './toolbarItemsList/MobileToolbarDoneButton';
import MobileImageTool from '../tools/imageTool/MobileImageTool';

type MobileToolbarToolListProps = {
    toolList: ToolbarList;
    index: number;
    gridSize: number;
    gridSizeName: string;
    debouncedProps: ToolbarItemsListRequiredProps;
    setDefaultToolbarType: (toolbarType: ToolbarListType) => void;
};

const MobileToolbarToolList = ({
    toolList,
    gridSize,
    gridSizeName,
    debouncedProps,
    setDefaultToolbarType,
}: MobileToolbarToolListProps) => {
    switch (toolList.type) {
        case ToolbarListType.MOBILE_TABS:
            return (
                <MobileTabsToolList
                    setDefaultToolbarType={setDefaultToolbarType}
                    permissions={toolList.capturedState?.permissions || 0}
                />
            );
        case ToolbarListType.MOBILE_UTILS:
            return <MobileUtilsToolList />;
        case ToolbarListType.EDITING:
        case ToolbarListType.EDITING_RANGE:
            return (
                <MobileToolbarItemsList
                    toolList={toolList}
                    gridSize={gridSize}
                    gridSizeName={gridSizeName}
                    debouncedProps={debouncedProps}
                    utilityItem={<MobileToolbarDoneButton setDefaultToolbarType={setDefaultToolbarType} />}
                />
            );
        case ToolbarListType.SELECTED:
            return (
                <MobileToolbarItemsList
                    toolList={toolList}
                    gridSize={gridSize}
                    gridSizeName={gridSizeName}
                    debouncedProps={debouncedProps}
                    utilityItem={
                        <MobileToolbarDoneButton
                            setDefaultToolbarType={setDefaultToolbarType}
                            className="align-with-title-tools"
                        />
                    }
                />
            );
        case ToolbarListType.CREATE_ELEMENT:
            return (
                <MobileToolbarItemsList
                    toolList={toolList}
                    gridSize={gridSize}
                    gridSizeName={gridSizeName}
                    debouncedProps={debouncedProps}
                    utilityItem={<MobileImageTool {...debouncedProps} />}
                />
            );
    }
};

export default MobileToolbarToolList;
